/** @format */
import { DashboardActions } from "../actionsName";

/** Set Dashboard */
export const setDashboard = (data) => ({
  type: DashboardActions.SET_DASHBOARD,
  data: data,
});

/** Delete Dashboard */
export const setClearDashboard = () => ({
  type: DashboardActions.CLEAR_DASHBOARD,
});
